import SocketBase from 'websockets/base';
import {snakeToCamel} from 'utils/common';

export default class AccountSocket extends SocketBase {
  constructor() {
    super({url: '/ws/account', socketClass: AccountSocket});
    this.processData = this.processData.bind(this);
    this.registerMessageHandler = this.registerMessageHandler.bind(this);
    this.unregisterMessageHandler = this.unregisterMessageHandler.bind(this);
    this.newMessageHandler = null;
  }

  processData(data) {
    let {type, payload} = data;
    payload = snakeToCamel(JSON.parse(payload));
    switch (data.type) {
      case 'messages.new_message':
        if (this.newMessageHandler) {
          this.newMessageHandler(payload);
        }
        break;
      default:
        throw Error(`Invalid type: ${type}`);
    }
  }

  registerMessageHandler(handler) {
    this.newMessageHandler = handler;
  }

  unregisterMessageHandler() {
    this.newMessageHandler = null;
  }
}
